import React from 'react'
import { MdLightbulbOutline, MdOutlineNature } from 'react-icons/md';
import { AiOutlineFundProjectionScreen } from 'react-icons/ai';
import "../css/About.css"
import "../css/index.css"
import img1 from "../img/A_highly_realistic_photo_of_a_professional_legal.png"

function About() {
  return (
    <section id="about">
      <div className="wrapper">
        <h2>Про нас</h2>
        <div className='title-border-simple'>
          <div className='title-border-colored'></div>
        </div>
        <div className="grid1">
          <div>
            <div className="icon">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                <g transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)" fill="#000000" stroke="none">
                  <path
                      d="M2491 4844 c-12 -9 -117 -142 -232 -296 -192 -256 -209 -282 -209 -319 0 -23 7 -53 17 -69 9 -16 90 -78 190 -144 l173 -117 0 -168 0 -169 -46 -23 c-26 -12 -70 -46 -99 -76 -29 -29 -59 -53 -67 -53 -7 0 -186 38 -396 85 -210 47 -400 85 -421 85 -54 0 -108 -46 -116 -98 -12 -72 -16 -82 -43 -113 -19 -21 -39 -32 -69 -36 -80 -11 -136 33 -149 118 -14 88 -55 129 -129 129 -76 0 -125 -54 -125 -137 0 -104 60 -223 146 -288 l41 -32 -348 -579 -348 -579 0 -60 c-2 -258 236 -498 579 -585 304 -77 643 -36 890 107 97 57 219 182 262 270 38 75 64 194 55 242 -3 15 -162 287 -352 604 l-346 577 55 51 c31 28 66 68 78 90 12 21 26 39 32 39 6 0 157 -33 335 -73 l325 -72 17 -59 c31 -104 124 -212 212 -245 l27 -11 0 -910 0 -910 -146 0 c-116 0 -151 -3 -172 -16 -15 -9 -121 -142 -236 -296 -195 -260 -209 -282 -209 -321 0 -53 15 -83 56 -107 31 -19 57 -20 837 -20 619 0 811 3 829 13 40 20 64 62 64 111 0 43 -10 58 -209 324 -115 154 -221 287 -236 296 -21 13 -56 16 -172 16 l-146 0 0 909 0 909 46 23 c26 12 70 46 99 76 29 29 59 53 67 53 14 0 692 -149 693 -153 1 -1 14 -28 29 -59 17 -36 49 -77 87 -112 l60 -56 -337 -561 c-185 -309 -343 -579 -352 -600 -21 -54 -3 -160 44 -259 28 -59 53 -92 122 -161 73 -71 105 -94 190 -137 56 -28 133 -60 170 -71 409 -122 882 -21 1112 236 28 32 70 96 93 142 40 80 42 88 42 175 l0 91 -342 568 c-189 313 -343 572 -343 575 0 4 25 28 55 55 74 65 116 151 123 252 l5 75 -41 40 c-34 34 -46 40 -82 40 -76 0 -121 -43 -134 -129 -4 -24 -11 -52 -17 -63 -17 -31 -70 -58 -116 -58 -56 0 -110 45 -118 98 -12 72 -16 82 -43 112 -26 30 -44 35 -441 123 l-414 92 -21 65 c-28 86 -83 160 -158 209 -33 23 -64 41 -69 41 -5 0 -9 76 -9 170 l0 169 173 117 c100 66 181 128 190 144 10 16 17 46 17 69 0 37 -17 63 -209 319 -115 154 -220 287 -232 296 -13 9 -43 16 -69 16 -26 0 -56 -7 -69 -16z m171 -456 l98 131 -100 68 -100 67 -100 -67 -100 -68 98 -131 c53 -72 99 -131 102 -131 3 0 49 59 102 131z m-43 -1076 c38 -20 71 -73 71 -112 0 -14 -8 -41 -18 -59 -20 -38 -73 -71 -112 -71 -62 0 -130 68 -130 130 0 62 68 130 130 130 14 0 41 -8 59 -18z m-952 -1219 l25 -43 -541 0 -540 0 270 451 271 451 245 -409 c135 -224 256 -427 270 -450z m2574 -108 l266 -445 -539 0 -540 0 14 23 c8 12 129 212 268 445 139 232 256 422 259 422 3 -1 126 -201 272 -445z m-2513 -227 c-56 -74 -186 -150 -320 -189 -94 -27 -306 -37 -414 -20 -155 26 -301 92 -386 176 -27 26 -48 51 -48 56 0 5 249 9 596 9 l597 0 -25 -32z m2816 -513 c-55 -72 -185 -148 -315 -185 -284 -79 -633 -15 -802 148 -82 79 -131 72 543 72 l601 0 -27 -35z m-1571 -602 l96 -128 -255 -3 c-140 -1 -368 -1 -508 0 l-255 3 96 128 95 127 318 0 318 0 95 -127z"/>
                </g>
              </svg>


            </div>
            <a href="#">Кримінальна справа?</a>
            <p>"Зіткнулися з кримінальними звинуваченнями? Наші кваліфіковані адвокати пропонують
              надійну юридичну підтримку та захист. Ми ретельно розбираємося в кожній справі,
              використовуючи глибоке знання кримінального законодавства, щоб забезпечити найкращий
              можливий результат для наших клієнтів. Більше 20 років досвіду.
              З нашими експертами ви можете бути впевнені в тому, що ваші права будуть захищені
              на кожному етапі процесу."</p>
          </div>
          <div>
            <div className="icon">
              <AiOutlineFundProjectionScreen/>
            </div>
            <a href="#">Потрапили в ДТП чи забрали права?</a>
            <p>"Були залучені в дорожньо-транспортну пригоду або стикалися з вилученням водійських прав?
              Наша команда досвідчених юристів пропонує експертну допомогу та захист у цих складних ситуаціях.
              Ми зосереджуємося на мінімізації вашого стресу та на забезпеченні найкращого можливого
              Від відновлення прав водіння до представництва ваших інтересів у суді, наша мета - відстояти
              ваші права та повернути спокій у ваше життя."</p>
          </div>
          <div>
            <div className="icon">
              <MdOutlineNature/>
            </div>
            <a href="#">Розлучення, сімейні конфлікти?</a>
            <p>"Станом перед розривом сімейних відносин або втягнуті в сімейні спори?
              Наші експерти з сімейного права допоможуть вам навігувати складними юридичними
              процесами та забезпечити захист вашим інтересам. Ми спеціалізуємося на розлученнях,
              розподілі майна, визначенні опіки над дітьми та вирішенні аліментних питань,
              пропонуючи компетентне представництво та співчуттєвий підхід.
              Наша мета - зробити перехід до нового етапу вашого життя якомога плавнішим та впевненішим."</p>
          </div>
        </div>

        <div className="grid2">
          <div>
            <h5>Стикаєтеся з правовими викликами в бізнесі або конкурентними спорами?</h5>
            <p>Наша команда висококваліфікованих юристів спеціалізується на комерційному
              та корпоративному праві, забезпечуючи комплексну правову підтримку від захисту
              комерційних інтересів до вирішення спорів з інстанціями та конкурентами.
              Ми пропонуємо стратегічні рішення, щоб ваш бізнес залишався на передові
              ринкової конкуренції, забезпечуючи ваше право на справедливу торгівлю та
              інноваційне зростання</p>

            <ul>
              <li>
                Learn More <a href="#about">About Us</a>
              </li>
            </ul>
          </div>
          <div className="right">
            <img src={img1 } alt="img" />
          </div>
        </div>
      </div>
    </section >
  )
}

export default About
